<template>
    <el-dialog
        :title="$t('Risk Improvement')"
        :visible.sync="show"
        append-to-body
        custom-class="rimodal"
        v-loading="loading"
        :close-on-click-modal="false"
        :width="!$client.isMobile ? '75%' : '90%'"
    >
        <riskimppanel
            :riskImprovement="riskImprovement"
            :question="question"
            :visit="visit"
        ></riskimppanel>
    </el-dialog>
</template>

<script>
import RiskImprovement from '@/data/RiskImprovement';
import FormQuestion from '@/data/FormQuestion';
import riskimppanel from '@/main/components/riskimprovement/riskimppanel.vue';

export default {
    name: 'rimodal',
    components: { riskimppanel },
    props: {
        value: Boolean,
        question: { type: FormQuestion, required: true },
        visit: null,
    },
    data() {
        return {
            riskImprovement: new RiskImprovement(),
            loading: false,
        };
    },
    created() {},
    mounted() {},
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    watch: {
        'question.data.id': {
            immediate: true,
            handler(v) {
                this.riskImprovement.form_ques_data_id = v;
            },
        },
    },
    methods: {},
};
</script>
<style lang="scss">
@import '@/styles/responsive.scss';
.rimodal {
    margin-top: 5vh !important;
}
</style>
